export const WHAT_IT_DOES = [
  'Reads your policies and rules once.',
  'Puts the right rules in front of the AI before it answers.',
  'Keeps a receipt so you can prove what the AI was told.',
]

/** Where instruction data comes from. `tone` colours the source code. */
export const SOURCES: ReadonlyArray<{ code: string; name: string; desc: string; tone: 'ink' | 'ink2' | 'amber' }> = [
  { code: 'REG', name: 'Regulations', desc: 'FDA, FINRA, HIPAA, state law', tone: 'ink' },
  { code: 'POL', name: 'Policies', desc: 'SOPs, brand book, review rules', tone: 'ink2' },
  { code: 'POL', name: 'Agent runbooks', desc: 'what each step may and may not do', tone: 'ink2' },
  { code: 'MTG', name: 'Meetings', desc: 'the correction everyone nodded at', tone: 'amber' },
  { code: 'FIX', name: 'Corrections', desc: 'your best reviewer’s red pen', tone: 'amber' },
  { code: 'FIX', name: 'AI chats', desc: 'the answer someone liked and kept', tone: 'amber' },
]

export const LIBRARY_TOTAL = '4,327'
export const LIBRARY_SPLIT = [
  { k: 'REG', v: '1,341' },
  { k: 'POL', v: '1,558' },
  { k: 'MTG', v: '519' },
  { k: 'FIX', v: '909' },
]

export const OWNERSHIP = [
  {
    t: 'Nothing trains anyone else’s model.',
    b: 'The library lives where your data lives. Your policies, your transcripts, your corrections never leave.',
  },
  {
    t: 'Switch models Tuesday. The library doesn’t notice.',
    b: 'Instruction data is readable by your compliance officer and compilable for any model you rent next.',
  },
  {
    t: 'The only part of your AI stack that appreciates.',
    b: 'Every correction your best people make gets atomized and versioned. Generic goes in once. What comes back is yours.',
  },
]

export const CHANGES = [
  {
    t: 'The first pass is the last pass.',
    b: 'The must-haves ride first, so drafts clear review the first time. The correction loop, and its token bill, collapses.',
  },
  {
    t: 'Every answer is on the record.',
    b: 'A signed receipt for each request: which rules fired, which versions, on what trigger. When the auditor asks, you show them.',
  },
  {
    t: 'Change the model. Keep the judgment.',
    b: 'The library compiles for whatever you rent next. Your rules stop living inside someone else’s model.',
  },
]

export const WHO_FOR = [
  {
    t: 'Pharma',
    b: 'The med-info reply, the HCP letter, the field email nobody templated.',
    tag: 'FDA · OPDP · FAIR BALANCE',
  },
  {
    t: 'Financial services',
    b: 'The client note that quotes a return, the retail communication that promises one.',
    tag: 'FINRA 2210 · SEC MARKETING RULE',
  },
  {
    t: 'Insurance',
    b: 'The denial letter, the prior authorization, the adverse determination.',
    tag: 'STATE DOI · UM STANDARDS',
  },
  {
    t: 'Agents, anywhere',
    b: 'Step three’s omission is step seven’s committed transaction. Obligations ride inside the chain, a receipt at every hop.',
    tag: 'YOUR RUNBOOKS · YOUR THRESHOLDS',
  },
]

/** "Works with" strip, two rows of six. `file` is the exported asset name; no file means a wordmark tile. */
export const BRAND_ROWS: ReadonlyArray<ReadonlyArray<{ name: string; file?: string; hideName?: boolean; tall?: boolean }>> = [
  [
    { name: 'OpenAI', file: 'brand-openai-icon.svg' },
    { name: 'Claude', file: 'brand-claude-icon.svg' },
    { name: 'Gemini', file: 'brand-google-gemini-icon.svg' },
    { name: 'Copilot', file: 'brand-copilot-color.svg' },
    { name: 'Microsoft', file: 'brand-microsoft-icon.svg' },
    { name: 'Squirro', file: 'squirro.png', tall: true },
  ],
  [
    { name: 'Slack', file: 'brand-slack-icon.svg' },
    { name: 'Gmail', file: 'brand-gmail-2020.svg' },
    { name: 'Outlook', file: 'brand-outlook.svg' },
    { name: 'n8n', file: 'brand-n8n.svg', hideName: true },
    { name: 'LangChain', file: 'brand-langchain-color.svg' },
    { name: 'Jev' },
  ],
]

export const TRUST = [
  {
    k: 'IN PRODUCTION WITH',
    t: 'Pharma, biotech,\nfinancial services',
    b: 'Live pilots in the workflows where being wrong costs the most.',
  },
  {
    k: 'PATENTS PENDING',
    t: 'Three provisional patents filed',
    b: 'One each for the Atomizer, the Composer, and the Compiler. USPTO, June 2026.',
  },
  {
    k: 'READY ON DAY ONE',
    t: '100,000 governed instructions',
    b: 'Regulatory, brand, and role baselines for the Fortune 1000 and their subsidiaries. Generic goes in once; yours comes back.',
  },
]
